var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"ebx-filter__checkbox-icon"})}
var staticRenderFns = []

export { render, staticRenderFns }